import Edit from '@package/components/Blocks/Title/Edit';

export default Edit;
